function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, StackItem, Text } from '@fluentui/react';
import * as React from 'react';
import { SitemapSectionColumn } from './sitemapSectionColumn';
export const SitemapSection = ({ title = '', rootLinkList = null, columns = [] })=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        className: "sitemap_section",
        tokens: {
            childrenGap: 's'
        },
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                className: "sitemap_section_root",
                tokens: {
                    childrenGap: 'l1'
                },
                children: [
                    /*#__PURE__*/ _jsx(StackItem, {
                        align: 'start',
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: 'xxLargePlus',
                            className: "sitemap_section_title",
                            as: "h1",
                            children: title
                        })
                    }),
                    rootLinkList && /*#__PURE__*/ _jsx(StackItem, {
                        align: 'start',
                        children: /*#__PURE__*/ _jsx(SitemapSectionColumn, _object_spread({}, rootLinkList))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Stack, {
                horizontal: true,
                wrap: true,
                className: "sitemap_columns",
                tokens: {
                    childrenGap: 'l2'
                },
                children: columns.map((column)=>/*#__PURE__*/ _jsx(SitemapSectionColumn, _object_spread({}, column), column.title))
            })
        ]
    });
};
